/* tslint:disable */
/* eslint-disable */
/**
 * driverRegistration driver-registration-portal api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 *
 * //!!!! WARNING !!!!!!!!
 * //This is an auto generated file.
 * //Changes to this code will be lost if the code is regenerated.
 */
import type { DriverRegistrationLogLastStep } from './DriverRegistrationLogLastStep';
import type { StepTranslations } from './StepTranslations';
import type { FieldResponse } from './FieldResponse';
import type { FlowCategory } from './FlowCategory';

export interface Step {
    id: DriverRegistrationLogLastStep;
    translations: StepTranslations;
    fields: Array<FieldResponse>;
    category?: FlowCategory;
}
